
const initialState = {
    abuseWord: [],
};

const abuseWordReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_ABUSE_WORDS_NAME":
            return state = {
                ...state,
                abuseWord: [action.payload, ...state.abuseWord ],
            }
        case "UPDATE_ABUSE_WORDS_NAME":
            return state = { ...state, abuseWord: state?.abuseWord?.map((abuseWord) => abuseWord._id === action.payload._id ? action?.payload : abuseWord)}

        case "UPDATE_ABUSE_WORDS_STATUS":
            return state = {
                ...state,
                abuseWord: state?.abuseWord?.map((abuseWord) =>
                    abuseWord._id === action.payload._id ? action?.payload : abuseWord
                ),
            }
            case "GET_ALL_ABUSE_WORDS":
                return {
                    ...state,
                    abuseWord: action.payload,
                };
        default:
            return state;
    }
}

export default abuseWordReducer;